import React, { useEffect, useState } from "react";
import moment from "moment";

import Table from "../../../../components/Table";
import Button from "../../../../components/Button";
import { ModalDelete } from "../../../../components/ModalDelete";

import api from "../../../../services/api";
import { renderError } from "../../../../helpers/errors";
import { convertIntToMoney } from "../../../../helpers/conversions";
import { useBillingCompanies } from "../../billingCompany";
import ModalTransfer from "../../components/ModalTransfer";

export const TransfersTab = () => {
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState(false);

    const [transfers, setTransfers] = useState([]);
    const [accounts, setAccounts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [transferToDelete, setTransferToDelete] = useState(null);

    const { hasMultiple: hasMultipleBillingCompanies } = useBillingCompanies();

    useEffect(() => {
        getTransfers();
        getAccounts();
    }, []);

    const getTransfers = () => {
        setLoading(true);

        api.get(`/finance-transfer`).then(res => {
            setTransfers(res.data.resources);
        }).catch(renderError).then(() => setLoading(false));
    };

    const getAccounts = () => {
        api.get(`/finance-bank-account`).then(res => {
            setAccounts(res.data.resources);
        }).catch(() => {});
    };

    const deleteTransfer = () => {
        setDeleting(true);

        api.delete(`/finance-transfer/${transferToDelete.id}`).then(() => {
            setTransferToDelete(null);
            getTransfers();
        }).catch(renderError).then(() => setDeleting(false));
    };

    const getAccountName = id => accounts.find(account => account.id === id)?.name ?? '';

    /**
     * Transferência entre contas de CNPJs diferentes não é transferência, é
     * mútuo entre as empresas: no consolidado zera, mas separado por empresa
     * vira saída numa e entrada na outra. Marcar é o que evita a pergunta do
     * contador depois. Conta sem empresa definida não caracteriza o caso.
     */
    const isCrossCompany = transfer => {
        const from = accounts.find(account => account.id === transfer.from_finance_bank_account_id);
        const to = accounts.find(account => account.id === transfer.to_finance_bank_account_id);

        return !!from?.billing_company_id
            && !!to?.billing_company_id
            && from.billing_company_id !== to.billing_company_id;
    };

    const rows = transfers.map(transfer => ({
        data: [
            moment(transfer.transferred_at).format('DD/MM/YYYY'),
            getAccountName(transfer.from_finance_bank_account_id),
            <>
                {getAccountName(transfer.to_finance_bank_account_id)}
                {hasMultipleBillingCompanies && isCrossCompany(transfer) &&
                    <span className={`finance-cross-company-tag`} title={`As contas são de empresas diferentes`}>entre empresas</span>
                }
            </>,
            convertIntToMoney(transfer.amount, true),
            transfer.description ?? '',
        ],
        buttons: [
            <Button type={`delete`} svg={`delete`} action={() => setTransferToDelete(transfer)} />,
        ],
    }));

    return (
        <>
            <ModalDelete
                show={transferToDelete !== null}
                text={<p>Tem certeza que deseja apagar esta transferência?</p>}
                action={deleteTransfer}
                loading={deleting}
                close={() => setTransferToDelete(null)}
            />
            <ModalTransfer
                show={showModal}
                close={() => setShowModal(false)}
                transfer={null}
                bankAccounts={accounts}
                onSaved={getTransfers}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 16 }}>
                <Button type={`primary`} size={`small`} svg={`plus-white`} text={`Nova transferência`} action={() => setShowModal(true)} />
            </div>
            <Table
                header={['Data', 'De', 'Para', 'Valor', 'Descrição', '']}
                rows={rows}
                loading={loading}
            />
        </>
    );
};

export default TransfersTab;
